@for (el of textAndStyle; track el) {
  <span ngClass='{{ el.style }}'>{{ el.text }}</span>
}
